module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col px-3 py-3 overflow-x-hidden"
  }, [_c('div', {
    staticClass: "overflow-x-auto sm:-mx-6 lg:-mx-8"
  }, [_c('div', {
    staticClass: "inline-block min-w-full sm:px-6 lg:px-8"
  }, [_c('div', {
    staticClass: "overflow-hidden border rounded-md"
  }, [_c('table', {
    staticClass: "min-w-full"
  }, [_c('thead', {
    staticClass: "bg-white dark:bg-gray-700"
  }, [_c('tr', [_c('th', {
    staticClass: "w-1/5 border-b py-2.5",
    attrs: {
      "colspan": "1"
    }
  }, [_c('div', [_c('span', {
    staticClass: "font-manrope font-normal"
  }, [_vm._v("Name")]), _vm._v(" "), (_vm.getCurrentRT.enable_annonymous) ? _c('button', {
    staticClass: "bg-white rounded ml-2 px-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.enableRealIdentity()
      }
    }
  }, [(_vm.privateIdentity === true) ? _c('i', {
    staticClass: "fa fa-solid fa-eye"
  }) : _c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "w-2/12 border-l border-r border-b bg-blueTable-light font-manrope font-normal",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                Submission\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "w-1/12 border-b border-r font-manrope font-normal"
  }, [_vm._v("Read")]), _vm._v(" "), _c('th', {
    staticClass: "w-1/12 border-b border-r bg-redTable-light font-manrope font-normal",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                Comments\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "bg-greenTable-light border-b font-manrope font-normal",
    attrs: {
      "colspan": _vm.assessmentsColspan + 3,
      "rowspan": "1"
    }
  }, [_vm._v("\n                Assessment\n              ")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "py-2.5 border-b border-r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrderList),
      expression: "selectedOrderList"
    }],
    staticClass: "px-3 py-1.5 text-sm font-normal text-gray-700 bg-white focus:text-gray-700 cursor-pointer focus:outline-none border rounded border-blueGray",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOrderList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name-asc"
    }
  }, [_vm._v("Name A-Z")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "name-desc"
    }
  }, [_vm._v("Name Z-A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "last-name-desc"
    }
  }, [_vm._v("Last Name Z-A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "last-name-asc"
    }
  }, [_vm._v("Last Name A-Z")])])]), _vm._v(" "), _c('th', {
    staticClass: "border-l border-b border-r bg-blueTable-light font-manrope font-normal"
  }, [_vm._v("\n                Complete\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "border-b border-r bg-blueTable-light font-manrope font-normal"
  }, [_vm._v("Words")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('th', {
    staticClass: "bg-redTable-light border-r border-b font-manrope font-normal"
  }, [_vm._v("Words")]), _vm._v(" "), _vm._l((_vm.assessments), function(a) {
    return (_vm.getCurrentRT.enable_grading === true) ? _c('th', {
      key: a.title,
      staticClass: "bg-greenTable-light border-r border-b font-manrope font-normal"
    }, [_vm._v("\n                " + _vm._s(a.title) + "\n              ")]) : _vm._e()
  }), _vm._v(" "), _c('th', {
    staticClass: "bg-greenTable-light border-r border-b font-manrope font-normal"
  }, [_vm._v("\n                Total Points\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "bg-greenTable-light border-r border-b font-manrope font-normal"
  }, [_vm._v("\n                Written Feedback\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "bg-greenTable-light border-b font-manrope font-normal"
  }, [_vm._v("Status")])], 2)]), _vm._v(" "), (_vm.isLoading === false) ? _c('tbody', _vm._l((_vm.orderedTableData), function(student) {
    return _c('tr', {
      key: student.id,
      staticClass: "border-b cursor-pointer"
    }, [_c('td', {
      staticClass: "px-4 py-3 border-r bg-white"
    }, [(_vm.privateIdentity === true) ? _c('div', {
      staticClass: "flex space-x-2 items-center"
    }, [_c('img', {
      staticClass: "inline-block h-10 w-10 rounded-full ring-2 ring-white mr-2",
      attrs: {
        "src": student.anonymous_identity.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col space-y-0.5"
    }, [_c('h6', {
      staticClass: "text-sm text-gray-800 font-poppins"
    }, [_vm._v(_vm._s(student.anonymous_identity.name))])])]) : _c('div', {
      staticClass: "flex space-x-2 items-center"
    }, [_c('img', {
      staticClass: "inline-block h-10 w-10 rounded-full ring-2 ring-white mr-2",
      attrs: {
        "src": student.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col space-y-0.5"
    }, [_c('h6', {
      staticClass: "text-sm text-gray-800 font-poppins"
    }, [_vm._v(_vm._s(student.name))]), _vm._v(" "), _c('span', {
      staticClass: "text-xs font-poppins text-gray-700 font-light"
    }, [_vm._v(_vm._s(student.anonymous_identity.name))])])])]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-blueTable-light"
    }, [(student.submission_started === true) ? _c('div', [_c('i', {
      staticClass: "ml-2 fa fa-solid fa-check"
    }), _vm._v(" "), _c('span', {
      staticClass: "underline cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.redirectToStudentFeedback(student.submission_id)
        }
      }
    }, [_vm._v("(View)")])]) : _c('i', {
      staticClass: "fa fa-solid fa-xmark"
    })]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-blueTable-light"
    }, [_vm._v("\n                " + _vm._s(student.submission_words) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-blueTable-light"
    }, [(student.is_model) ? _c('i', {
      staticClass: "ml-2 fa fa-solid fa-check text-green-500"
    }) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-white"
    }, [_vm._v("\n                " + _vm._s(student.read) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-redTable-light"
    }, [_vm._v("\n                " + _vm._s(student.comments_number) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-redTable-light"
    }, [_vm._v("\n                " + _vm._s(student.comments_average_length) + "\n              ")]), _vm._v(" "), _vm._l((student.assessments), function(s) {
      return (student.assessments.length && _vm.getCurrentRT.enable_grading === true) ? _c('td', {
        key: s.title,
        staticClass: "border-r text-center bg-greenTable-light"
      }, [_vm._v("\n                " + _vm._s(s.value) + "\n              ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((student.draft_assessments), function(d) {
      return (!student.assessments.length && student.draft_assessments.length && _vm.getCurrentRT.enable_grading === true) ? _c('td', {
        key: d.title,
        staticClass: "border-r text-center bg-greenTable-light"
      }, [_vm._v("\n                " + _vm._s(d.value) + "\n              ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.assessments), function(a) {
      return (!student.assessments.length && !student.draft_assessments.length && _vm.getCurrentRT.enable_grading === true) ? _c('td', {
        key: a.title,
        staticClass: "border-r text-center bg-greenTable-light"
      }, [_vm._v("\n                -\n              ")]) : _vm._e()
    }), _vm._v(" "), (!student.assessments.length && student.draft_assessments.length) ? _c('td', {
      staticClass: "border-r text-center bg-greenTable-light"
    }, [_vm._v("\n                " + _vm._s(student.total_draft_points) + "\n              ")]) : _vm._e(), _vm._v(" "), (student.assessments.length) ? _c('td', {
      staticClass: "border-r text-center bg-greenTable-light"
    }, [_vm._v("\n                " + _vm._s(student.total_points) + "\n              ")]) : _vm._e(), _vm._v(" "), (!student.assessments.length && !student.draft_assessments.length) ? _c('td', {
      staticClass: "border-r text-center bg-greenTable-light"
    }, [_vm._v("\n                -\n              ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "border-r text-center bg-greenTable-light"
    }, [(student.teacher_feedback !== '') ? _c('div', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), (student.teacher_feedback === '' && student.draft_teacher_feedback === '') ? _c('div', [_vm._v("\n                  -\n                ")]) : _vm._e(), _vm._v(" "), (student.draft_teacher_feedback !== '' && student.teacher_feedback === '') ? _c('div', [_vm._v("\n                  Draft\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center bg-greenTable-light"
    }, [(student.assessments.length || student.teacher_feedback !== '') ? _c('div', {
      attrs: {
        "\class": "hover:underline text-green-500"
      },
      on: {
        "click": function($event) {
          return _vm.redirectToStudent(student.submission_id)
        }
      }
    }, [_vm._v("\n                  Sent\n                ")]) : (student.draft_assessments.length || student.draft_teacher_feedback !== '') ? _c('div', {
      staticClass: "hover:underline",
      on: {
        "click": function($event) {
          return _vm.redirectToStudent(student.submission_id)
        }
      }
    }, [_vm._v("\n                  Draft\n                ")]) : _c('div', [_vm._v("-")])])], 2)
  }), 0) : _c('tbody', _vm._l((2), function(skeletonLoader, index) {
    return _c('tr', {
      key: index,
      staticClass: "border-b"
    }, [_vm._m(3, true), _vm._v(" "), _vm._l((_vm.skeletonLoaders), function(skeletonLoader, index1) {
      return _c('td', {
        key: index1,
        staticClass: "p-3 border-r bg-gray-50",
        attrs: {
          "rowspan": "1"
        }
      }, [_c('div', {
        staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
      })])
    })], 2)
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "border-r border-b bg-blueTable-light font-manrope font-normal"
  }, [_c('i', {
    staticClass: "fa fa-solid fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "border-b border-r"
  }, [_c('i', {
    staticClass: "fa fa-solid fa-percent"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "bg-redTable-light border-r border-b"
  }, [_c('i', {
    staticClass: "fa fa-solid fa-hashtag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "p-3 border-r bg-gray-50",
    attrs: {
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "flex items-center animate-pulse"
  }, [_c('div', {
    staticClass: "w-8 bg-gray-300 h-7 mr-2 rounded-full"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full h-3 bg-gray-200 dark:bg-gray-700"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-318d2bc2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/summaryComponents/StudentsTable.vue
// module id = 1136
// module chunks = 61